export enum CustomerFormMode {
    Add,
    Update
}